let rootSelector = '.c-team__inner';

function init() {
  const accordions = document.querySelectorAll(rootSelector);

  if (!accordions.length) {
    return;
  }

  Array.from(accordions).forEach((accordion) => {
    buildAccordion(accordion);
    resizeColumns();
  });

  window.addEventListener('resize', () => {
    resizeColumns();
    resizeItems();
  });

}

function buildAccordion(accordion) {
  let items = accordion.querySelectorAll('.c-team-card');

  Array.from(items).forEach((item) => {

    item.addEventListener('click', (e) => {

      item = document.querySelectorAll("#info_" + e.target.closest('.c-team-card').dataset.container);
      const card = document.querySelectorAll("#card_" + e.target.closest('.c-team-card').dataset.container);
      e.preventDefault();
      resetActive(item[0], card[0]);
      setActive(item[0], card[0]);

    });

  });
}

function resetActive(item, card) {

  let items = document.querySelectorAll('.c-team-card');

  if (!item.classList.contains('is-active') && document.querySelectorAll('.is-active').length) {

    Array.from(items).forEach((card_item) => {

      let info_item = document.querySelectorAll("#info_" + card_item.dataset.container)[0];
      card_item = document.querySelectorAll("#card_" + card_item.dataset.container)[0];

      if (card_item.classList.contains('is-active')) {

        let more_about = card_item.querySelectorAll(`.c-team-card__team_button`)[0];

        info_item.style.height = '0px';
        if (more_about.dataset.name) {
          more_about.innerHTML = more_about.dataset.name;
        }

        card_item.classList.remove('is-active');
        info_item.classList.remove('is-active');

      }

      card_item.animate([ {opacity: 0.3}, {opacity: 1} ], 350);
      card_item.style.opacity = '1';

    });

  }

}

function setActive(item, card) {
  let content = item;
  let inner_content = item.querySelectorAll(`.c-team-info__inner`)[0];
  let more_about = card.querySelectorAll(`.c-team-card__team_button`)[0];

  if (item.classList.contains('is-active')) {
    item.style.height = '0px';
    more_about.innerHTML = more_about.dataset.name;
    let items = document.querySelectorAll('.c-team-card');
    Array.from(items).forEach((card_item) => {
      if (!card_item.classList.contains('is-active')) {
        card_item.animate([ {opacity: 0.3}, {opacity: 1} ], 350);
        card_item.style.opacity = '1';
      }
    });
    item.classList.remove('is-active');
    card.classList.remove('is-active');

  } else {
    let { height } = inner_content.getBoundingClientRect();
    height = height + 140;
    item.style.height = `${height}px`;
    item.classList.add('is-active');
    card.classList.add('is-active');
    more_about.setAttribute('data-name', more_about.innerHTML)
    more_about.innerHTML = "Close";
    let items = document.querySelectorAll('.c-team-card');
    Array.from(items).forEach((card_item) => {
      if (!card_item.classList.contains('is-active')) {
        card_item.animate([ {opacity: 1}, {opacity: 0.3} ], 350);
        card_item.style.opacity = '0.3';
      }
    });
  }
}

function resizeItems() {
  let items = document.querySelectorAll(`c-team-card`);

  if (!items.length) {
    return;
  }

  Array.from(items).forEach((item) => {
    const content = item;
    const inner_content = item.querySelectorAll(`.c-team-info__inner`)[0];

    if (item.classList.contains('is-active')) {
      let { height } = inner_content.getBoundingClientRect();
      content.style.height = `${height}px`;
    }
  });
}

function resizeColumns() {

  let items = document.querySelectorAll(`.c-team-card`);
  let item_infos = document.querySelectorAll(`.c-team-info`);

  if (window.innerWidth < 768) {

    let i = 0;
    Array.from(items).forEach((item) => {
      item.style["order"] = (2 * i);
      item_infos[i].style["order"] = ((2 * i) + 1);
      i = i + 1;
    });

  } else if(window.innerWidth < 990) {

    for (var x = 0; x < items.length; x++) {

      var item = items[x];
      var new_x = x;
      if((x % 2) == 0) {
        item.style["order"] = new_x;
      } else {
        item.style["order"] = new_x - 1;
        new_x = new_x + 2
      }

    }

    for (var y = 0; y < item_infos.length; y++) {

      var item = item_infos[y];
      var new_y = y + 1;
      if((y % 2) == 0) {
        item.style["order"] = new_y;
      } else {
        item.style["order"] = new_y - 1;
        new_y = new_y + 2;
      }

    }

  } else {

    let i = 0;
    Array.from(items).forEach((item) => {
      item.style["order"] = null;
      item_infos[i].style["order"] = null;
      i = i + 1;
    });

  }

}

export default init;
